import { render, staticRenderFns } from "./TrainingMap.vue?vue&type=template&id=3ddcd660"
import script from "./TrainingMap.vue?vue&type=script&lang=js"
export * from "./TrainingMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports